<app-modal class="error-container"
           [(visible)]="visible"
           [foreground]="true"
           (onHide)="clearErrors()"
           header="You have the following error(s) with your submission:">
  <p *ngFor="let error of errors; trackBy: trackByIndex">
    {{error.validationMessage}}
  </p>
</app-modal>
